// extracted by mini-css-extract-plugin
module.exports = {"content":"dp-GLEPTz9M","mainContent":"dp-gE5ZVSCq","title":"dp-Sg1x5FJm","inputContainer":"dp-2hi6YmYz","searchBtn":"dp-GSG5gH3w"};